frappe.ui.form.ControlHeading = frappe.ui.form.ControlHTML.extend({
	get_content: function() {
		if(this.df.columns >0){
			return "<h4 class='form-heading col-sm-"+this.df.columns+"' >" + __(this.df.label) + "</h4>";
		}
		else{
			if (this.df.label == undefined) {
				return "<h4 style='display: none;' >" + __(this.df.label) + "</h4>";
			}
			return "<h4>" + __(this.df.label) + "</h4>";
		}
	}
});
